import ContextProvider, { MainContext } from './MainContext';

export { MainContext };

export default ContextProvider;
